import React from "react";
import Navbar from "../components/navbar";
import { Footer } from "../components/Footer";
import { Box } from "@mui/material";
import Counter from "../components/Counter";
import Team from "../components/ourTeam";
import ImageCarousel from "../components/ImageCarousel";
import UnderstandOurServices from "../components/UnderstandOurServices";
import OurMissionWriteUp from "../components/OurMissionWriteUp";
import WhoAreWeWriteUp from "../components/WhoAreWeWriteUp";
import OurStarStudent from "../components/OurStarStudent";
import AboutStudentsPics from "../components/AboutStudentsPics";

export const Aboutus = () => {
  return (
    <div>
      <Navbar />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignContent: "center",
        }}
      >
        <Box
          style={{
            height: {
              xs: "89vh",
              sm: "85vh",
            },
            width: "100%",
          }}
        >
          <div className="cover-2">
            <div
              style={{ position: "absolute", fontFamily: "Aclonica" }}
              className="about-nas-logo-txt"
            >
              {/* <p
                className="ceo-name"
                style={{ padding: 0, paddingBottom: "3px", margin: 0 }}
              >
                Shishir Singh
              </p>
              <p className="ceo-pos">Founder & CEO</p>
              <div className="qualifications">
                <p
                  style={{
                    margin: 0,
                    padding: 0,
                    paddingBottom: "3px",
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  National Winner at Nasscom’s Cohort-6
                </p>
                <p
                  style={{
                    margin: 0,
                    padding: 0,
                    paddingBottom: "3px",
                  }}
                >
                  An alumni of CHS ( BHU )
                </p>
                <p style={{ padding: 0, paddingBottom: "3px", margin: 0 }}>
                  JEE advance Qualified
                </p>
              </div> */}
            </div>
          </div>
        </Box>
        {/* <ImageCarousel /> */}
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <div
            className="who-are-we"
            style={{ padding: "20px 0px", width: "80%" }}
          >
            <div className="row" style={{ width: "95%" }}>
              <p className="title-about col-sm-12 col-md-12 col-lg-5">
                Who are we?
              </p>
              <div className="col-sm-12 col-md-12 col-lg-7">
                {/* <WhoAreWeWriteUp /> */}
                <p>
                  We are building a structured solution to one of the most
                  overlooked gaps in India’s education system career
                  decision-making at an early stage. At YAPASSIO, we believe
                  that choosing a career is not a one-time decision but a
                  continuous journey that requires exposure, awareness, and the
                  ability to make informed choices.
                </p>
                <p>
                  {" "}
                  Instead of relying on one-time counselling or exam-driven
                  guidance, we integrate career discovery directly into the
                  school curriculum from Classes 6 to 10, aligned with NEP and
                  CBSE vocational goals. Through consistent, real-world exposure
                  to different streams, skills, and career paths, we help
                  students develop clarity, confidence, and decision-making
                  ability over time. By the time they reach Class 10, they are
                  not guessing their future, they understand it, and with the
                  support of our AI-driven platform, they are equipped to choose
                  and pursue the right path in the best possible way.
                </p>
              </div>
            </div>
            {/* <img src='about-us-cover.png' style={{height:'100%', width:'95%', objectFit:'cover', borderRadius:'30px', objectPosition: '50%'}}/>
                <img src='image 21.png' style={{position:'absolute', right:'10%'}}/> */}
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            marginTop: "80px",
          }}
        >
          {/* <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignContent: "center",
              padding: "20px 0px",
              width: "90%",
              borderRadius: "20px",
              boxShadow: "0px 7px 8px #afafaf",
            }}
          >
            <div className="" style={{ width: "100%" }}>
              <div
                className=""
                style={{ display: "flex", justifyContent: "center" }}
              >
                <p className="title-about">Understand our services</p>
              </div>
            </div>
            <UnderstandOurServices />
          </div> */}
        </div>
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <div
            style={{ padding: "50px 0px", width: "90%", borderRadius: "20px" }}
          >
            <img style={{ width: "100%" }} src="problem-solving.png" />
          </div>
        </div>
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        ></div>
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <div
            style={{ padding: "20px 0px", width: "90%", borderRadius: "20px" }}
          >
            <div className="row" style={{ width: "100%" }}>
              <div
                className="col-sm-12"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <p className="title-about" style={{ textAlign: "center" }}>
                  Our Cohort-6 Winning team
                </p>
                <div style={{ objectFit: "contain" }}>
                  <img
                    style={{ width: "100%" }}
                    src="Cohort-6 Winning Team.jpg"
                  />
                </div>
                {/* <p></p> */}
              </div>
            </div>
          </div>
        </div>
        <Team />
        <div id="our-star-student">
          <OurStarStudent />
        </div>
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <div
            style={{
              padding: "20px 20px",
              width: "90%",
              borderRadius: "20px",
              boxShadow: " 0 10px 20px rgba(0,0,0,0.3)",
              marginTop: "35px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div className="row" style={{ width: "100%" }}>
              <div
                className="col-sm-12"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignContent: "center",
                }}
              >
                <p className="title-about">Our Mission</p>
                {/* <p></p> */}
              </div>
              <p>
                To transform career decision-making into a continuous,
                structured journey by integrating real-world exposure, skill
                development, and self-discovery into the school system from
                Classes 6 to 10 enabling every student to make informed,
                confident choices about their future.
              </p>
              {/* <OurMissionWriteUp /> */}
            </div>
          </div>
        </div>
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <div
            style={{
              padding: "20px 20px",
              width: "90%",
              borderRadius: "20px",
              boxShadow: " 0 10px 20px rgba(0,0,0,0.3)",
              marginTop: "35px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div className="row" style={{ width: "100%" }}>
              <div
                className="col-sm-12"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignContent: "center",
                }}
              >
                <p className="title-about">Our Values</p>
                {/* <p></p> */}
              </div>
              <p>
                We believe in starting early, because the right exposure at the
                right time shapes better decisions. We focus on building clarity
                over confusion by replacing one-time advice with continuous
                exploration. We value real understanding over assumptions,
                ensuring students experience different career paths rather than
                just hearing about them. We are committed to integration, not
                addition working within school systems without creating extra
                burden on students or teachers. And most importantly, we believe
                in empowering students with the ability to decide, not just
                guiding them on what to choose, supported by data, experience,
                and evolving self-awareness.
              </p>
              {/* <OurMissionWriteUp /> */}
            </div>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            marginTop: "50px",
          }}
        >
          <div style={{ padding: "0px", width: "90%", borderRadius: "20px" }}>
            <div className="row" style={{ width: "100%" }}>
              <div
                className="col-sm-12"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <p className="title-about">Our Trainees</p>
                {/* <p></p> */}
              </div>
            </div>
          </div>
        </div>
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <div
            style={{ padding: "0px 0px", width: "90%", borderRadius: "20px" }}
          >
            <img style={{ width: "100%" }} src="trainees.png" />
          </div>
        </div>
        <div class="stats-section" style={{ marginTop: "50px" }}>
          <div class="row">
            <div class="col-4 col-md-3 stats-col">
              <div class="stat-box yellow">
                <div class="counter-wrapper">
                  <Counter targetNumber={15000} />
                </div>
                <p class="stat-text user-interactions">
                  User
                  <br />
                  Interactions
                </p>
              </div>
              <div class="stat-box purple" style={{ marginTop: "20px" }}>
                <div class="counter-wrapper">
                  <Counter targetNumber={1000} />
                </div>
                <p class="stat-text total-users">No. of Indirect Users</p>
              </div>
            </div>

            <div class="col-4 col-md-6 image-col">
              <div>
                <picture class="inner-image">
                  <source
                    media="(max-width: 768px)"
                    srcset="small-screen.jpg"
                  />
                  <source media="(min-width: 769px)" srcset="big-screen.jpg" />
                  <img
                    src="big-screen.jpg"
                    class="employee-image"
                    alt="Employee Onboarding"
                  />
                </picture>
              </div>
            </div>

            <div class="col-4 col-md-3 stats-col">
              <div class="stat-box green">
                <div class="counter-wrapper">
                  <Counter targetNumber={25} />
                </div>
                <p class="stat-text collaborations">
                  Collaborations
                  <br />/ Affiliations
                </p>
              </div>
              <div class="stat-box red" style={{ marginTop: "20px" }}>
                <div class="counter-wrapper">
                  <Counter targetNumber={50} />
                </div>
                <p class="stat-text interns">Interns till Date</p>
              </div>
            </div>
          </div>
        </div>
        <div style={{ marginTop: "50px" }}>
          <AboutStudentsPics />
        </div>
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <div
            style={{ padding: "20px 0px", width: "90%", borderRadius: "20px" }}
          >
            <img style={{ width: "100%" }} src="empowering girls.png" />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
